<template>
  <b-container class="concursos">
    <h2>Concursos</h2>
    <div class="concursos-body">
      <div class="concursos-list" v-loading="loading">
        <ul>
          <li
            :class="{
              'concursos-list__item': true,
              active: isActive(`${item.id}`),
            }"
            v-for="item in concursos"
            :key="item.id"
          >
            <a
              :class="{
                'concursos-list__item-link': true,
                active: isActive(`${item.id}`),
              }"
              @click.prevent="setActive(`${item.id}`)"
              :href="`#${item.categoria}`"
              >{{ item.categoria }}</a
            >
          </li>
        </ul>
      </div>
      <div
        class="concursos-component"
        v-loading="loadingActive"
        v-if="!loading"
      >
        <ul>
          <li v-for="data in concursoActive.data" :key="data.id">
            <a :href="data.arquivo" target="_blank">{{ data.titulo }}</a>
          </li>
        </ul>

        <div class="pg" v-if="Object.keys(concursoActive).length > 0">
          <b-pagination
            class="pt-5"
            align="center"
            v-model="concursoActive.current_page"
            pills
            :total-rows="concursoActive.total"
            @change="handleChangePage"
            :per-page="concursoActive.per_page"
          ></b-pagination>
        </div>
      </div>
    </div>
  </b-container>
</template>

<script>
export default {
  name: "licitações",
  data() {
    return {
      loading: false,
      loadingActive: false,
      concursos: [
        {
          id: 2,
          categoria: "Editais e Documentos Oficiais",
        },
        {
          id: 1,
          categoria: "Outros Editais e Documentos",
        },
      ],
      concursoActive: [],

      activeItem: "",
    };
  },
  computed: {
    modalOpen: {
      get() {
        return this.open;
      },
      set(value) {
        this.open = value;
      },
    },
  },
  methods: {
    async getConcursoActive(id, pg = 1) {
      this.loadingActive = true;
      window.scrollTo({
        top: 0,
      });
      const res = await this.$axios
        .get(`concursos/${id}?page=${pg}`)
        .catch((e) => {
          console.error("Concurso", e);
        });
      if (res.status === 200) {
        this.concursoActive = res.data;
      }
      this.loadingActive = false;
    },
    handleChangePage(pg) {
      this.getConcursoActive(this.activeItem, pg);
    },
    isActive(menuItem) {
      return this.activeItem.toString() === menuItem.toString();
    },
    setActive(menuItem) {
      this.activeItem = menuItem;
      this.getConcursoActive(menuItem);
    },
  },

  created() {
    this.setActive(2);
  },
};
</script>

<style lang="scss">
.concursos {
  &.container {
    padding: 30px 20px;
    text-align: left;
  }
  font-family: Poppins;
  // font-size: 14px;
  font-size: var(--font-size--default);
  h4,
  h2 {
    color: var(--color-text-title);
    font-weight: bold;
    text-align: left;
  }

  &-body {
    display: flex;
  }

  &-list {
    ul {
      list-style: none;
      padding: 0;
      margin: 0;

      li {
        background: var(--background-color-secondary);
        padding: 20px;
        border-radius: 0;
        margin: 0 1px 0 0;
        font-style: normal;
        font-weight: 400;
        border-top: 1px solid #dddddd;
        width: 300px;

        &:first-child {
          border-top: none;
        }
        & a {
          color: #87a8cc;
          &.active {
            color: #1f387f;
          }
        }

        &.active {
          background: #87a8cc;
        }
      }
    }
  }

  &-component {
    padding: 0 20px;
    ul {
      list-style: none;
      padding: 0;
      margin: 0;

      li {
        border-top: 1px solid #dddddd;
        padding: 10px 0;
        text-align: justify;
        &:first-child {
          border-top: none;
        }
        span {
          color: #007bff;
          text-decoration: none;
          background-color: transparent;
          cursor: pointer;
          &:hover {
            color: #0056b3;
            text-decoration: underline;
          }
        }
      }
    }
    .pg {
      ul {
        li {
          border: none;
        }
      }
    }
  }
}
.custom-content {
  ul {
    list-style: none;
    padding: 0 10px;
    margin: 0;
    li {
      padding: 10px;
    }
  }
}

@media only screen and (max-width: 936px) {
  .concursos {
    &-body {
      flex-direction: column-reverse;
      align-items: center;
    }
  }
}
</style>
